import { BaseQueryFn } from '@reduxjs/toolkit/query/react';
import keycloak from 'app/config/keycloak';
import { getCurrentAccountId } from 'app/shared/api/accountContext';
import axios, { AxiosError, AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';

export const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: '' },
  ): BaseQueryFn<
    {
      url: string;
      method?: AxiosRequestConfig['method'];
      body?: AxiosRequestConfig['data'];
      params?: AxiosRequestConfig['params'];
      header?: AxiosRequestConfig['headers'];
      timeout?: number;
    },
    unknown,
    unknown
  > =>
  async ({ url, method, body, params, header, timeout }) => {
    try {
      const requestConfig: AxiosRequestConfig = {
        url: baseUrl + url,
        method: method ? method.toLowerCase() : 'get',
        data: body,
        params,
        headers: { ...header },
        ...(typeof timeout === 'number' ? { timeout } : {}),
      };

      if (keycloak.authenticated && keycloak?.token) {
        requestConfig.headers = {
          ...requestConfig.headers,
          Authorization: `Bearer ${keycloak.token}`,
        };
      }

      const accountId = getCurrentAccountId();
      if (accountId) {
        requestConfig.headers = {
          ...requestConfig.headers,
          'X-Account-Id': accountId,
        };
      }

      const result = await axios(requestConfig);
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const arrayParamsInterceptor = (config: InternalAxiosRequestConfig) => {
  if (config.params) {
    Object.keys(config.params).forEach(key => {
      const paramValue = config.params[key];

      if (Array.isArray(paramValue) && typeof paramValue[0] === 'string') {
        config.params[key] = paramValue.join(',');
      }
    });
  }

  return config;
};
